// extracted by mini-css-extract-plugin
export default {"card":"StatTableCard-module__card--x2EpU","statBlock":"StatTableCard-module__statBlock--PpPEh"};